import React from "react";

import { GoogleSpreadsheet } from "google-spreadsheet";

// core components
import IndexNavbar from "components/Navbars/IndexNavbar.js";
import IndexHeader from "components/Headers/IndexHeader.js";
import DarkFooter from "components/Footers/DarkFooter.js";

// sections for this page
import Tabs from "./index-sections/Tabs.js";
import TableChoice from "./index-sections/TableChoice.js";
import MenuProgramme from "./index-sections/MenuProgramme.js";
import Contacts from "./index-sections/Contacts.js";

function Index() {
  React.useEffect(() => {

    document.body.classList.add("index-page");
    document.body.classList.add("sidebar-collapse");
    document.documentElement.classList.remove("nav-open");
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    return function cleanup() {
      document.body.classList.remove("index-page");
      document.body.classList.remove("sidebar-collapse");
    };
  });
  
  const SPREADSHEET_ID = process.env.REACT_APP_SPREADSHEET_ID;
  const SHEET_ID = process.env.REACT_APP_SHEET_ID;
  const CLIENT_EMAIL = process.env.REACT_APP_GOOGLE_CLIENT_EMAIL;
  const PRIVATE_KEY = process.env.REACT_APP_GOOGLE_SERVICE_PRIVATE_KEY.replace(/\\n/g, '\n');
  
  const doc = new GoogleSpreadsheet(SPREADSHEET_ID)

  const [isFree, setIsFree] = React.useState({
    prop: [],
    update: 0
  });

  const [displayTable, setDisplayTable] = React.useState(false)
  const [loading, setLoading] = React.useState(false)
  const [formReceived, setFormReceived] = React.useState(false)

  const tableFormat = (tableName) => {
    return (parseInt(tableName[0], 36) - 10) * 11 + parseInt(tableName.slice(1))
  }

  const dateFormat = (currentTime) => {
    var date = currentTime.getFullYear() + '-' + (currentTime.getMonth() + 1) + '-' + currentTime.getDate()
    var time = currentTime.getHours() + ":" + currentTime.getMinutes() + ":" + currentTime.getSeconds()
    return( date + ' ' + time )
  }

  const scrollToMap = () => {
    document.getElementById("table-scroll").scrollIntoView();
  }

  const validFormSent = (tableName) => {
    alert("Place réservée table " + tableName)
    setFormReceived(true)
    setDisplayTable(false)
    setTimeout(function() {    
        window.scrollTo({
            left: 0,
            top: document.getElementById("table-scroll2").getBoundingClientRect().y,
            })}, 500
        );
  }

  const resID = Math.random().toString().substring(2, 8)
  
  const appendSpreadsheet = async (row) => {
    try {
      await doc.useServiceAccountAuth({
        client_email: CLIENT_EMAIL,
        private_key: PRIVATE_KEY
      });

      // loads document properties and worksheets
      await doc.loadInfo();

      const sheet1 = doc.sheetsById[0];
      const sheet2 = doc.sheetsById[SHEET_ID];

      const nbTable = tableFormat(row[0].table.toString()) 
      //console.log("row",row)
      //console.log(row[0].table)
      const rows = await sheet2.getRows()
      const nbRes = rows[nbTable].nombre
      //console.log(rows[nbTable].nombre)
      if (nbRes < 11 - row.length) {
        rows[nbTable].nombre = parseInt(rows[nbTable].nombre) + row.length
        await rows[nbTable].save()
        const result = await sheet1.addRows(row.map(function(it) {return {...it, id: resID, date: dateFormat(new Date())}}))
                        .then((_) =>  validFormSent(row[0].table))
      } else {
        isFree.prop[nbTable] = 10
        alert("Cette table est déjà remplie (" + row.length + " demandée(s) pour " + (10 - nbRes) + " disponible(s)" + ")")
      }

    } catch (e) {
      console.error('Error: ', e);
      alert("Une erreur a été détectée (ajout d'une réservation), veuillez contacter le gala pour votre réservation.")
    }
  };

  const updateButton = async (e) => {
    e.preventDefault()
    try {
      await doc.useServiceAccountAuth({
        client_email: CLIENT_EMAIL,
        private_key: PRIVATE_KEY
      });
      // loads document properties and worksheets
      await doc.loadInfo(); 

      const sheet1 = doc.sheetsById[0];
      const sheet2 = doc.sheetsById[SHEET_ID];
      const rows = sheet2.getRows()

      rows.then (data => {
           for (let i = 0; i < data.length; i++) {
            setIsFree(s => ({...s, prop: [...s.prop, parseInt(data[i].nombre)]}))
            setDisplayTable(true)
            setLoading(false)
            scrollToMap()
          } 
        })
        .catch((error) => {
          console.error(error)
          alert('Une erreur a été détectée (chargement des tables), veuillez contacter le gala pour votre réservation.')
        })

    } catch (e) {
      console.error('Error: ', e);
      alert('Une erreur a été détectée (chargement des tables), veuillez contacter le gala pour votre réservation.')
    }
  }

  return (
    <>
      <IndexNavbar loading={loading} formReceived={formReceived}/>
      <div className="wrapper">
        <IndexHeader/>
        <div className="main">
        <Tabs />
        <MenuProgramme />
        <TableChoice toSheet={(row) => appendSpreadsheet(row)} formReceived={formReceived} setFormReceived={setFormReceived} isFree={isFree.prop} updateTable={updateButton} displayTable={displayTable} setDisplayTable={setDisplayTable} setLoading={setLoading} scrollToMap={scrollToMap}/>
        <Contacts />
        </div>
        <DarkFooter />
      </div>
    </>
  );
}

export default Index;
